<template>
  <!-- 语言 v-if="$route.params.uuid"-->
  <v-card>
    <v-card-text>
      <v-col cols=" 12">
        <v-select v-model="select1"
                  :items="listitems"
                  :disabled="readonly"
                  height="40"
                  :placeholder="readonly ?' ':$t('label_Other_languages')"
                  :background-color="readonly ? '#fff' : '#f5f5f5'"
                  :append-icon="readonly ? '' : 'arrow_drop_down'"
                  item-text="view_fields"
                  item-value="value_field"
                  :label="$t('label_The_default_language') + '*'"
                  :readonly="readonly"></v-select>
      </v-col>
      <v-col cols="12">
        <v-select v-model="select2"
                  :items="listitems"
                  :background-color="readonly ? '#fff' : '#f5f5f5'"
                  height="40"
                  :placeholder="readonly ?' ':$t('label_Other_languages')"
                  chips
                  :disabled="readonly"
                  @change="change"
                  :append-icon="readonly ? '' : 'arrow_drop_down'"
                  item-text="view_fields"
                  item-value="value_field"
                  multiple
                  :label="$t('label_Other_languages')"
                  :readonly="readonly"></v-select>
      </v-col>
    </v-card-text>
    <slot name="submitBtn"> </slot>
  </v-card>
</template>

<script>
import { getBusinessList } from '@/service/api/func_module.js'
export default {
  props: {
    label: {},
    list: {
      type: Array,
      default: () => [],
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      nodorules: [
        (v) => String(v).length <= 200 || '超过输入个数',
        (v) => !/[@#$%^&()<>?/]/.test(v) || '请勿输入非法字符',
        (v) => !/^ +| +$/g.test(v) || '不能输入空格',
      ],
      // readonly: false,
      select1: '', //预设语言
      select2: [], //其他语言
      listitems: [], //下拉选择list
      ysdefault: {}, //预设默认选择  判断用户是否修改
      otherlanguagelist: [], //  保存用户修改前的其他语言
    }
  },
  watch: {
    list: {
      handler (val) {
        // console.log('yuyan', val);
        this.list = val
        this.getlanguage(this.list)
      },
      deep: true,
    },
    // iconstatus (v) {
    //   this.readonly = v
    // }
  },
  computed: {
    mrbase_sys_client_language () {
      //处理语言代码逻辑
      if (!this.select1) return false //预设语言不能为空
      if (
        !this.select2.every((item) => {
          return item != this.select1
        })
      )
        return false
      let arr = {
        is_default_language: 1, //是否默认值 0否 1 是（必填）
        '~table~': 'mrbase_sys_client_language', //表名 （必填）
        client_language_code: this.select1,
      }
      let arr2 = this.select2.map((item) => {
        return {
          is_default_language: 0, //是否默认值 0否 1 是（必填）
          '~table~': 'mrbase_sys_client_language', //表名 （必填）
          client_language_code: item,
        }
      })
      return [{ ...arr }, ...arr2]
      //------------------ 分割线----------------------------
      //------------------ 分割线----------------------------
      //------------------ 分割线----------------------------
      if (!this.select1.length > 0) return false //语言不能为空
      const languagelist = [] //预设语言
      if (this.select1 === this.ysdefault.client_language_code) {
        languagelist.push(this.ysdefault)
      } else {
        languagelist.push({
          is_default_language: 1, //是否默认值 0否 1 是（必填）
          '~table~': 'mrbase_sys_client_language', //表名 （必填）
          client_language_code: this.select1,
        })
      }

      // 判断select语言修改了什么
      var result = [] // 删除的语言加typedel
      var result2 = [] //未删除的语言不加
      var otherresult = [] //新增的语言 需要加上其他字段
      for (var i = 0; i < this.otherlanguagelist.length; i++) {
        var client_language_code = this.otherlanguagelist[i]
          .client_language_code
        var isExist = false
        for (let j = 0; j < this.select2.length; j++) {
          if (this.select2[j] == client_language_code) {
            isExist = true
            break
          }
        }
        if (!isExist) {
          result.push({ ...this.otherlanguagelist[i], '~type~': 'del' })
        } else {
          result2.push(this.otherlanguagelist[i])
        }
      }

      for (var i = 0; i < this.select2.length; i++) {
        var client_language_code = this.select2[i]
        var isExist = false
        for (let j = 0; j < result2.length; j++) {
          if (result2[j].client_language_code === client_language_code) {
            isExist = true
            break
          }
        }
        if (!isExist) {
          otherresult.push({
            is_default_language: 0,
            '~table~': 'mrbase_sys_client_language',
            client_language_code: this.select2[i],
          })
        }
      }
      const isequality = [...result2, ...otherresult].every((item) => {
        return item.client_language_code != languagelist[0].client_language_code
      })
      if (isequality) {
        return [...languagelist, ...result, ...result2, ...otherresult]
      } else {
        return false
      }
      // console.log('删除的语言加typedel', result);
      // console.log('未删除的语言不加', result2);
      // console.log('新增的语言 需要加上其他字段', otherresult);
    },
  },
  async mounted () {
    // const res = await getBusinessList('user_default_language')
    const res = await getBusinessList('client_language')
    // console.log(res.data);
    // res.data.map(item => {  //下拉列表
    //   this.listitems.push(item.view_fields)
    // })
    this.listitems = res.data
    if (this.$route.params.uuid || this.$store.state.detailuuid) {
      //查看详情
      this.readonly = true
      if (this.list) {
        this.getlanguage(this.list)
      }
    } else {
    }
  },
  methods: {
    change (v) { },
    getlanguage (val) {
      this.select2 = [] //先清空在获取最新数据
      val.map((item, index) => {
        //获取数据
        if (item.is_default_language == 1) {
          //应该等于1
          // this.select1 = val[index].client_language_code  //数据要处理
          // this.ysdefault = val[index]
          this.select1 = item.client_language_code
        } else {
          // this.select2.push(val[index].client_language_code)
          // this.otherlanguagelist.push(val[index])
          this.select2.push(item.client_language_code)
        }
      })
    },
    changeis (item) {
      // item.is_default_language = 1
    },
    changeno (item) {
      // item.is_default_language = 0
    },
  },
}
</script>

<style scoped>
/deep/ .v-input__append-inner {
  margin-top: 8px;
  margin-right: 8px;
}
/deep/ .v-input__slot {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}
/deep/.v-input .v-label {
  top: 2px !important;
}
/deep/ .v-list-item__content {
  min-height: 40px !important;
  max-height: 56px !important;
}
.v-input--selection-controls {
  margin: 0;
  padding: 0;
}
/deep/ .v-select__slot {
  min-height: 40px;
}
/deep/ .v-select__selections {
  min-height: 40px;
  padding-left: 8px;
}
/* /deep/ .v-list-item {
  min-height: 40px !important;
  padding: 0;
} */
/deep/ .v-list-item__content {
  min-height: 40px !important;
}
/* /deep/ .v-input__append-inner {
  margin-top: 8px;
  margin-right: 8px;
} */
</style>
